const MINIMO_COLUNAS_REGISTROS = 2

/**
 * Maior quantidade de registros entre as linhas exportadas — define quantas
 * colunas de batida o CSV terá. Não muta as linhas recebidas (o array vem do
 * cache do React Query e é a fonte da ordem exibida na grid).
 */
export function maximoRegistros(
    linhas: Array<{ registros?: unknown[] | null }>,
) {
    const maior = linhas.reduce(
        (acc, linha) => Math.max(acc, linha.registros?.length ?? 0),
        0,
    )

    return Math.max(maior, MINIMO_COLUNAS_REGISTROS)
}
